import {PackageTemplate} from "../entities/PackageTemplate";
import apiClient from "./http";
import {Response} from "../entities/Response";
import {DEPLOY_ENV} from "../utils/config";

export class PackageTemplateService {

    static async createTemplate(template: PackageTemplate) : Promise<Response<any>> {
        return await apiClient.post('/service/package/template/create', template);
    }

    static async updateTemplate(template: PackageTemplate) : Promise<Response<any>> {
        return await apiClient.post('/service/package/template/update', template);
    }

    static async getTemplate(request: { appKey: string, env: string }) : Promise<Response<PackageTemplate | null>> {
        return await apiClient.post('/service/package/template/get', request);
    }

}